import { useSpaceIDFromPath } from '@/data/space/hooks';
import { useListEmailMessagesQuery } from '@/store';
import { EnvelopeSimple } from '@phosphor-icons/react';
import { MenuNav } from '../Nav';

export function MenuMails() {
  const spaceID = useSpaceIDFromPath();
  const { data: emailsData } = useListEmailMessagesQuery([spaceID], { skip: !spaceID });

  return (
    <div className="mb-[24px]">
      {emailsData?.map((email) => (
        <MenuNav
          key={email.id}
          href={`/email/${spaceID}/${email.id}`}
          pre={<EnvelopeSimple size={16} weight="bold" className="text-secondary" />}
        >
          {email.document?.subject || ''}
        </MenuNav>
      ))}
    </div>
  );
}
